import { Injectable } from '@angular/core';
import { ServicingBaseClass } from '@common/components';
import { AMCMemberStoreService, CommonLibService } from '@lib/services';
import { PREVIOUS_PAGE_IDENTIFIER, SEARCH_TYPE } from '@common/interfaces';
import { LoginStatusType } from '@lib/interfaces';
import { TravelerNamesInner } from 'src/sdk-servicing';
import { ServicingCommonStoreService } from '../servicing-common-store/servicing-common-store.service';
import { SERVICING_ROUTES } from '@conf/routes.config';

@Injectable()
export class ReceiptSelectService extends ServicingBaseClass {
  override destroy(): void {}
  constructor(
    private _commonLibService: CommonLibService,
    private _amcMemberStoreService: AMCMemberStoreService,
    private _servicingCommonStoreService: ServicingCommonStoreService
  ) {
    super();
  }

  /**
   * 領収書オプション入力モーダルの宛名入力欄の初期値を取得。
   * @param travleraName リスト中の最初の搭乗者名情報。
   * @param searchType 検索種別。
   */
  getDefaultReceivedFrom(travleraName: TravelerNamesInner, searchType: SEARCH_TYPE) {
    if (this.isRealLogin && searchType !== SEARCH_TYPE.E_TICKET_AND_EMD_BY_PNR_FOR_RECEIPT) {
      // REAL_LOGIN 且つ 領収書検索(P05-S010)からの遷移のときは会員情報.able-I用氏名を参照
      const givenName =
        this._amcMemberStoreService?.amcMemberData?.iFlyMemberInfo?.profileDetails?.individualInfo?.givenName;
      const familyName =
        this._amcMemberStoreService?.amcMemberData?.iFlyMemberInfo?.profileDetails?.individualInfo?.familyName;

      if (givenName && familyName) {
        return `${givenName} ${familyName}`;
      }
    }
    return `${travleraName.firstName} ${travleraName.lastName}`;
  }

  /**
   * ユーザー共通.ログインステータス が REAL_LOGIN であることを示す。
   */
  get isRealLogin() {
    return this._commonLibService.aswContextStoreService.aswContextData.loginStatus === LoginStatusType.REAL_LOGIN;
  }

  /**
   * 遷移元画面が領収書検索(P05-S010)であることを示す。
   */
  get isPreviousPageReceiptSearch() {
    return (
      this._servicingCommonStoreService.servicingCommon.previousPageIdentifier ===
      PREVIOUS_PAGE_IDENTIFIER.RECEIPT_SEARCH
    );
  }

  /**
   * 遷移元画面のパス。
   */
  get previousPageRoutes() {
    return this.isPreviousPageReceiptSearch ? SERVICING_ROUTES.receiptSearch : SERVICING_ROUTES.myBooking;
  }
}
